import {
  DefaultFetchError,
  FetchCreate,
  FetchDelete,
  FetchGet,
  FetchGetId,
  FetchSuccess,
  FetchUpdate,
  PagingDataResponse,
  PagingParams,
  useFetchCreate,
  useFetchDelete,
  useFetchGet,
  useFetchGetId,
  useFetchUpdate,
} from "../fetch";
import dayjs, { Dayjs } from "dayjs";
import { User, UserStatusType } from "../../store/auth";

export interface UsersGetParams extends PagingParams {
  fullName?: string;
  orderByColumn?: "username" | "firstName";
}

export interface UserCreateParams extends Omit<
  User,
  | "birthdate"
  | "settings"
  | "isTwoFAActive"
  | "firstName"
  | "lastName"
  | "status"
> {
  birthdate?: Dayjs | null;
  status?: string;
}

export type UserUpsetParams = Omit<UserCreateParams, "id">;

interface AdministratorsGetParams extends PagingParams {
  orderByColumn?: "username" | "firstName";
}

export const useStaffGetAll = <DD = UsersTableData>(
  decorateData?: (data: PagingDataResponse<User>) => DD,
): FetchGet<
  PagingDataResponse<User>,
  AdministratorsGetParams,
  DefaultFetchError,
  DD
> =>
  useFetchGet("users/staff", {
    autoStart: false,
    startStateLoading: false,
    decorateData,
  });

export interface UserTableRow extends Omit<User, "settings"> {
  key: string;
  subscriptionStatus?: string;
  // fullName: string;
}

export interface UsersTableData {
  data: UserTableRow[];
  total: number;
}

export const useStaffTableGet = () =>
  useStaffGetAll<UsersTableData>(
    ({ data, meta }: PagingDataResponse<User>): UsersTableData => ({
      data: data.map(
        ({ settings, ...item }: User): UserTableRow => ({
          key: item.id,
          // fullName: `${item.firstName || "-"}`,
          ...item,
        }),
      ),
      total: meta.itemCount,
    }),
  );

export const useUserGetById = <DD = User>(
  id?: string,
  decorateData?: (data: User) => DD,
): FetchGetId<User, DefaultFetchError, unknown, DD> =>
  useFetchGetId("users", id, {
    autoStart: false,
    decorateData,
  });

export const useUserCreate = (): FetchCreate<
  UserCreateParams,
  DefaultFetchError,
  UserUpsetParams
> => useFetchCreate("users");

export type UserUpdateParams = Partial<UserCreateParams>;

export const useUserUpdate = (
  id?: string,
): FetchUpdate<UserUpdateParams, DefaultFetchError, UserUpdateParams> =>
  useFetchUpdate("users", id);

export const useUserDelete = (
  id?: string,
): FetchDelete<FetchSuccess, DefaultFetchError> => useFetchDelete("users", id);

export const useUsersGet = (): FetchGet<
  PagingDataResponse<User>,
  UsersGetParams
> => useFetchGet("users", { autoStart: false, startStateLoading: false });

export default {
  useUsersGet,
};
